import type { Price } from '@/types';

// Payment linkage depends on these plans using backend-created Stripe Checkout
// Sessions. Do not add Stripe Payment Link / buy.stripe.com URLs here: direct
// Payment Links bypass /user_payments/:id/stripe_session, so the backend may
// never create the UserPayment.customer_id needed to match subscription webhooks.
// See docs/payments.md before changing this flow.

// Define enum values as constants to avoid circular import issues in tests
const PlanTypes = {
  classic: 0,
  exec: 1,
} as const;

export const PRICES: Array<Price> = [
  {
    additionalFeatures: [
      'Two <strong>45-minute</strong> Coaching Sessions per month',
      'Email and chat communication with your coach',
      'Dedicated Concierge',
      'Access to Mento Tools: Growth Plan and Peer Insights',
    ],
    amount: 625,
    feature:
      'Access to all coaches, <strong>excluding</strong> Executive Level Coaches',
    frequency: 'month',
    id: {
      production: 'price_1TcWRDDl97h2uSSXQZB4hDFv',
      test: 'price_1MyNP4Dl97h2uSSX94EAJhPc',
    },
    pill: 'Director-Level and below',
    title: 'Mento Coaching',
    type: PlanTypes.classic,
  },
  {
    additionalFeatures: [
      'Two <strong>60-minute</strong> Coaching Sessions per month',
      '<strong>Unlimited</strong> chat and email support between sessions; <strong/>ad hoc coaching</strong> sessions when needed',
      'Dedicated Concierge',
      'Access to Mento Tools: Growth Plan and Peer Insights',
      'Access to Tripartites & 360s',
    ],
    amount: 1250,
    feature:
      '<strong>Exclusive Access to Coaches</strong> who are <strong>founders and C-Suite executives</strong>',
    frequency: 'month',
    id: {
      production: 'price_1U5sHgDl97h2uSSXMOUzoQV9',
      test: 'price_1PJcvPDl97h2uSSXYruKBFhh',
    },
    pill: 'Founders & Executives',
    title: 'Mento Executive Coaching',
    type: PlanTypes.exec,
  },
];

export const ANUAL_PRICES: Array<Price> = [
  {
    additionalFeatures: [
      'Two <strong>45-minute</strong> Coaching Sessions per month',
      'Email and chat communication with your coach',
      'Dedicated Concierge',
      'Access to Mento Tools: Growth Plan and Peer Insights',
    ],
    amount: 6750,
    displayPrice: '$562.50 / month',
    feature:
      'Access to all coaches, <strong>excluding</strong> Executive Level Coaches',
    frequency: 'year',
    id: {
      production: 'price_1U5pLWDl97h2uSSXgQZ9Lvqp',
      test: 'price_1MyNPlDl97h2uSSX3LERBcpo',
    },
    pill: 'Director-Level and below',
    sub: 'billed annually',
    title: 'Mento Coaching',
    type: PlanTypes.classic,
  },
  {
    additionalFeatures: [
      'Two <strong>60-minute</strong> Coaching Sessions per month',
      '<strong>Unlimited</strong> chat and email support between sessions; <strong/>ad hoc coaching sessions</strong> when needed',
      'Dedicated Concierge',
      'Access to Mento Tools: Growth Plan and Peer Insights',
      'Access to Tripartites & 360s',
    ],
    amount: 13500,
    displayPrice: '$1,125 / month',
    feature:
      '<strong>Exclusive Access to Coaches</strong> who are <strong>founders and C-Suite executives</strong>',
    frequency: 'year',
    id: {
      production: 'price_1U5sIjDl97h2uSSXavQnRsjl',
      test: 'price_1PJcw6Dl97h2uSSX0gNHxwvZ',
    },
    pill: 'Founders & Executives',
    sub: 'billed annually',
    title: 'Mento Executive Coaching',
    type: PlanTypes.exec,
  },
];
